import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { API, fileUpload } from "../../../config";
import {
  getContractorDetail,
  useStateList,
  useBankList,
} from "./components/SubContractorHelper";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "./components/Form";
import Spin from "../../common/Spin";
import { AddContractorSchema } from "../../common/Validation";
import { formatedPostalCode, formatName } from "../../common/Misc";
import ProjectSubHeader from "../components/ProjectSubHeader";

const EditSubContractor = () => {
  const navigate = useNavigate();
  const params = useParams();
  const projectId = params?.project_id;
  const [loading, setLoading] = useState(false);
  const [contractorData, setContractorData] = useState();
  const formValues = useRef();
  const contractorId = params?.sub_contractor_id;
  let existingValues = [];
  let overwrittenFields = [];

  // Fetching the Subcontractor Details
  useEffect(() => {
    async function fetchData() {
      try {
        // await getUsers();
        setLoading(true);
        const data = await getContractorDetail(contractorId);
        setContractorData(data);
        setLoading(false);
      } catch (e) {
        setContractorData(null);
      }
    }
    fetchData();
  }, [contractorId]);

  // Edit Subcontractor Function
  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";
    value.opening_balance = Number(
      `${value?.opening_balance}`.replace(/,/g, "")
    );
    // value.contract_value = Number(`${value?.contract_value}`.replace(/,/g, ""));

    // value.retention_amount = Number(
    //   `${value?.retention_value}`.replace(/,/g, "")
    // );

    // value.retention_percentage = Number(
    //   `${value?.retention_precentage}`.replace("%", "")
    // );

    value.contact_type_id = value?.contact_type_id?.id;
    value.state_id = value?.state_id?.value;
    value.suburb_id = value?.suburb_id?.id;
    value.bank_id = value?.bank_id?.value;

    value.shipping_state_id = value?.shipping_state_id?.value;
    value.shipping_suburb_id = value?.shipping_suburb_id?.id;

    formData.append("builder_project_id", projectId);
    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("phone", value?.phone ? value?.phone : "");
    formData.append("mobile", value?.mobile ? value?.mobile : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : ""
    );
    formData.append(
      "contact_type_id",
      value?.contact_type_id ? value?.contact_type_id : ""
    );
    formData.append(
      "qbcc_number",
      value?.qbcc_number ? value?.qbcc_number : ""
    );

    formData.append("representative_name", value?.representative_name ? value?.representative_name : "");
    formData.append(
      "representative_email",
      value?.representative_email ? value?.representative_email : ""
    );
    // formData.append("representative_phone", value?.representative_phone ? value?.representative_phone : "");

    formData.append("internal_contact_name", value?.internal_contact_name ? value?.internal_contact_name : "");
    formData.append(
      "internal_contact_email",
      value?.internal_contact_email ? value?.internal_contact_email : ""
    );


    formData.append("abn", value?.abn);
    formData.append("_method", "put");
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );
    formData.append(
      "shipping_street",
      value?.shipping_street ? value?.shipping_street : ""
    );
    formData.append(
      "shipping_state_id",
      value?.shipping_state_id ? value?.shipping_state_id : ""
    );
    formData.append(
      "shipping_suburb_id",
      value?.shipping_suburb_id ? value?.shipping_suburb_id : ""
    );
    formData.append(
      "shipping_postal_code",
      value?.shipping_postal_code ? value?.shipping_postal_code : ""
    );
    formData.append(
      "account_name",
      value?.account_name ? value?.account_name : ""
    );
    formData.append("bsb", value?.bsb ? value?.bsb : "");
    formData.append(
      "account_number",
      value?.account_number ? value?.account_number : ""
    );
    formData.append(
      "opening_balance",
      value?.opening_balance ? value?.opening_balance : 0
    );
    formData.append("bank_id", value?.bank_id ? value?.bank_id : "");

    // formData.append(
    //   "contract_file",
    //   value?.contract_file ? value?.contract_file : ""
    // );

    // formData.append(
    //   "contract_value",
    //   value?.contract_value ? value?.contract_value : ""
    // );

    // formData.append(
    //   "retention_amount",
    //   value?.retention_amount ? value?.retention_amount : ""
    // );
    // formData.append(
    //   "retention_percentage",
    //   value?.retention_percentage ? value?.retention_percentage : ""
    // );
    let contracts = value?.contracts;

    for (
      let contractIndex = 0;
      contractIndex < contracts?.length;
      contractIndex++
    ) {
      if (contracts[contractIndex].contract_value) {
        contracts[contractIndex].contract_value = Number(
          `${contracts[contractIndex].contract_value}`.replace(/,/g, "")
        );
        contracts[contractIndex].contract_value_exc = Number(
          `${contracts[contractIndex].contract_value_exc}`.replace(/,/g, "")
        );

        contracts[contractIndex].retention_amount = Number(
          `${contracts[contractIndex]?.retention_amount}`.replace(/,/g, "")
        );

        contracts[contractIndex].retention_percentage = Number(
          `${contracts[contractIndex]?.retention_percentage}`.replace("%", "")
        );
        formData.append(
          `contracts[${contractIndex}][contract_id]`,
          contracts[contractIndex].id &&
            contracts[contractIndex].id !== undefined
            ? contracts[contractIndex].id
            : ""
        );

        if (contracts[contractIndex].id) {
          if (contracts[contractIndex].contract_number) {
            formData.append(
              `contracts[${contractIndex}][contract_number]`,
              contracts[contractIndex].contract_number
                ? contracts[contractIndex].contract_number
                : ""
            );
          } else {
            formData.append(
              `contracts[${contractIndex}][contract_number]`,
              contractorData?.contracts?.find(
                (item) => item?.id === contracts[contractIndex].id
              )?.contract_number
            );
          }
        } else {
          formData.append(
            `contracts[${contractIndex}][contract_number]`,
            contracts[contractIndex].contract_number
              ? contracts[contractIndex].contract_number
              : ""
          );
        }

        formData.append(
          `contracts[${contractIndex}][contract_value]`,
          contracts[contractIndex].contract_value
            ? contracts[contractIndex].contract_value
            : ""
        );
        formData.append(
          `contracts[${contractIndex}][contract_value_exc]`,
          contracts[contractIndex].contract_value_exc
            ? contracts[contractIndex].contract_value_exc
            : ""
        );
        formData.append(
          `contracts[${contractIndex}][retention_amount]`,
          contracts[contractIndex].retention_amount
            ? contracts[contractIndex].retention_amount
            : "0"
        );
        formData.append(
          `contracts[${contractIndex}][retention_percentage]`,
          contracts[contractIndex].retention_percentage
            ? contracts[contractIndex].retention_percentage
            : "0"
        );
        formData.append(
          `contracts[${contractIndex}][contract_file]`,
          contracts[contractIndex].contract_file
            ? contracts[contractIndex].contract_file
            : ""
        );
      }
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.CONTRACTOR_Add}/${contractorId}`,
        formData
      );
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        // navigate(-1);
        navigate("/projects/" + projectId + "/sub-contractors");
      }
      return data?.data;
    } catch (error) {
      setContractorData(value);
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) => item?.value === contractorData?.state_id
  );

  //ShippingState
  const shippingState = stateListing?.find(
    (item) => item?.value === contractorData?.shipping_state_id
  );

  //Bank
  const { bankLoading, bankList = [] } = useBankList();
  const bankListing = bankList ? bankList : [];
  const projectBank = bankListing?.find(
    (item) => item?.value === contractorData?.bank_id
  );

  // ContractorType
  const ContractorType = contractorData?.contact_type
    ? {
        id: contractorData?.contact_type?.id
          ? contractorData?.contact_type?.id
          : "",
        label: contractorData?.contact_type?.name,
      }
    : null;
  return (
    <div className="cms-page">
      <div className="page-content-block">
        <div className="full-content-block">
          <ProjectSubHeader
            title={formatName(
              contractorData?.first_name,
              contractorData?.last_name
            )}
          />
          <div className="content-details">
            <section>
              <Formik
                initialValues={{
                  first_name: contractorData?.first_name,
                  last_name: contractorData?.last_name,
                  phone: contractorData?.phone,
                  mobile: contractorData?.mobile,
                  email: contractorData?.email,
                  business_name: contractorData?.business_name,
                  abn: contractorData?.abn,
                  contact_type_id: ContractorType ? ContractorType : null,
                  qbcc_number: contractorData?.qbcc_number,

                  representative_name: contractorData?.representative_name ? contractorData?.representative_name : "",
                  representative_email: contractorData?.representative_email ? contractorData?.representative_email : "",
                  // representative_phone: contractorData?.representative_phone ? contractorData?.representative_phone : "",

                  internal_contact_name: contractorData?.internal_contact_name ? contractorData?.internal_contact_name : "",
                  internal_contact_email: contractorData?.internal_contact_email ? contractorData?.internal_contact_email : "",

                  street: contractorData?.street,
                  state_id: state,
                  suburb_id: contractorData?.suburb,
                  postal_code: formatedPostalCode(contractorData?.postal_code),

                  same_address: false,

                  shipping_street: contractorData?.shipping_street,
                  shipping_state_id: shippingState,
                  shipping_suburb_id: contractorData?.shipping_suburb,
                  shipping_postal_code: formatedPostalCode(
                    contractorData?.shipping_postal_code
                  ),
                  account_name: contractorData?.account_name
                    ? contractorData?.account_name
                    : "",
                  bsb: contractorData?.bsb ? contractorData?.bsb : "",
                  account_number: contractorData?.account_number
                    ? contractorData?.account_number
                    : "",
                  opening_balance: contractorData?.opening_balance
                    ? contractorData?.opening_balance
                    : 0,
                  bank_id: projectBank ? projectBank : "",
                  // contract_value: contractorData?.contract_value
                  //   ? contractorData?.contract_value
                  //   : "",
                  // contract_file: contractorData?.contract_file
                  //   ? contractorData?.contract_file
                  //   : "",
                  //   retention_amount: contractorData?.retention_amount
                  //   ? contractorData?.retention_amount
                  //   : "",
                  // retention_precentage: contractorData?.retention_percentage
                  //   ? contractorData?.retention_percentage
                  //   : "",
                  contracts:
                    contractorData?.contracts?.length > 0
                      ? contractorData?.contracts
                      : [
                          {
                            tempId: 1,
                            contract_number: "",
                            contract_value: "",
                            contract_value_exc: "",
                            contract_file: "",
                            retention_amount: "",
                            retention_percentage: "",
                          },
                        ],
                }}
                enableReinitialize
                innerRef={formValues}
                onSubmit={handleFormSubmit}
                validateOnBlur={true}
                validateOnChange={true}
                validationSchema={AddContractorSchema}
              >
                {({
                  values,
                  setErrors,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  return (
                    <>
                      {loading && <Spin />}
                      <Form
                        values={values}
                        errors={errors}
                        setErrors={setErrors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        formValues={formValues}
                        overwrittenFields={overwrittenFields}
                        existingValues={existingValues}
                        stateListing={stateListing}
                        stateLoading={stateLoading}
                        bankListing={bankListing}
                        bankLoading={bankLoading}
                        projectId={projectId}
                        edit={true}
                      />
                    </>
                  );
                }}
              </Formik>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSubContractor;
